<div id="filters">
  <div class="filter">
    <div>
      <select [(ngModel)]="year" (change)="onFilter()">
        <option *ngFor="let item of yearFilterOptions" [value]="item.value">
          {{ item.label }}
        </option>
      </select>
    </div>
  </div>
  <div class="filter">
    <div>
      <select [(ngModel)]="month" (change)="onFilter()">
        <option *ngFor="let item of monthFilterOptions" [value]="item.value">
          {{ item.label }}
        </option>
      </select>
    </div>
  </div>
</div>
<div id="month-overview" class="container">
  <div class="row">
    <div class="col-sm">
      <p>
        {{ 'label.Month' | translate }}:
        {{
          monthNames[reportData?.monthOverview?.month - 1]
            ? 'label.' + monthNames[reportData?.monthOverview?.month - 1]
            : ''
        }}
      </p>
      <p>
        {{ 'label.NumberOfWorkdaysShort' | translate }}:
        {{ reportData?.monthOverview?.workingDays }}
      </p>
      <p>
        {{ 'label.NumberOfTotalDaysShort' | translate }}:
        {{ reportData?.monthOverview?.totalDays }}
      </p>
      <p>
        {{ 'label.NumberOfHolidaysShort' | translate }}:
        {{ reportData?.monthOverview?.holidays }}
      </p>
      <p>
        {{ 'label.Saturday' | translate }}:
        {{ reportData?.monthOverview?.saturdays }}
      </p>
      <p>
        {{ 'label.ElapsedWorkdays' | translate }}:
        {{ reportData?.monthOverview?.workingDaysGone }}
      </p>
    </div>
    <div class="col-sm">
      <p>
        {{ 'label.NumberOfCurrentCustomersShort' | translate }}:
        {{ reportData?.monthOverview?.customers }}
      </p>
      <p>
        {{ 'label.NumberOfCustomersAtTheStartOfMonthShort' | translate }}:
        {{ reportData?.monthOverview?.customersAtStart }}
      </p>
      <p>
        {{ 'label.NumberOfNewCustomersShort' | translate }}:
        {{ reportData?.monthOverview?.newCustomers }}
      </p>
      <p>
        {{ 'label.InactiveForTheLastSixMonths' | translate }}:
        {{ reportData?.monthOverview?.inactiveCustomers }}
      </p>
    </div>
    <div class="col-sm">
      <p>
        {{ 'label.TotalCurrentDebt' | translate }}:
        {{ reportData?.monthOverview?.debt }}
      </p>
      <p>
        {{ 'label.DebtAtTheStartOfMonthShort' | translate }}:
        {{ reportData?.monthOverview?.debtAtStart }}
      </p>
      <p>
        {{ 'label.CurrentMonthDebt' | translate }}:
        {{ reportData?.monthOverview?.newDebt }}
      </p>
      <p>
        {{ 'label.LastThreeMonthDebt' | translate }}:
        {{ reportData?.monthOverview?.lastThreeMonthDebt }}
      </p>
      <p>
        {{ 'label.DebtBeforeThreeMonth' | translate }}:
        {{ reportData?.monthOverview?.debtBeforeLastThreeMonth }}
      </p>
      <p>
        {{ 'label.DebtBeforeSixMonth' | translate }}:
        {{ reportData?.monthOverview?.debtBeforeLastSixMonth }}
      </p>
    </div>
    <div class="col-sm">
      <p>
        {{ 'label.InvoiceTotal' | translate }}:
        {{ reportData?.monthOverview?.invoices }}
      </p>
      <p>
        {{ 'label.SalesBeforeDiscount' | translate }}:
        {{ reportData?.monthOverview?.orderTotals }}
      </p>
      <p>
        {{ 'label.Discount' | translate }}:
        {{ reportData?.monthOverview?.discount }}%
      </p>
    </div>
  </div>
</div>
<div id="table">
  <p-treeTable [value]="reportData?.tableData" [autoLayout]="true">
    <ng-template pTemplate="header" let-columns>
      <tr *ngIf="reportData?.portfolioDetails">
        <th></th>
        <th colspan="4" *ngFor="let id of portfolios">
          <div *ngIf="reportData?.portfolioDetails[id]">
            <span
              >{{ 'label.Customers' | translate }}:
              <span style="font-weight: initial">{{
                reportData?.portfolioDetails[id].customers
              }}</span></span
            ><br />
            <span
              >{{ 'label.TotalDebt' | translate }}:
              <span style="font-weight: initial">{{
                reportData?.portfolioDetails[id].totalDebt
              }}</span></span
            >
          </div>
        </th>
      </tr>
      <tr *ngIf="reportData?.portfolioDetails">
        <th></th>
        <th colspan="4" *ngFor="let id of portfolios">
          {{ reportData?.portfolioDetails[id]?.portfolioName }}
        </th>
      </tr>
      <tr>
        <th *ngFor="let col of cols">
          {{ col.header }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
      <tr [ngClass]="{ 'parrent-row': rowData.isParrent }">
        <td *ngFor="let col of cols; let i = index">
          <p-treeTableToggler
            [rowNode]="rowNode"
            *ngIf="i == 0"
          ></p-treeTableToggler>
          <span
            [ngClass]="
              col.colored ? getCellStyleClass(rowData[col.field]) : null
            "
            >{{ rowData[col.field] != null ? rowData[col.field] : '-' }}</span
          >
          <br *ngIf="i == 0" />
          <span
            *ngIf="rowData[col.field + 'Sold'] != null"
            [ngClass]="
              col.colored
                ? getCellStyleClass(rowData[col.field + 'Sold'])
                : null
            "
            >{{ rowData[col.field + 'Sold'] }}
          </span>
        </td>
      </tr>
    </ng-template>
  </p-treeTable>
</div>
